import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import PageForm from '../Form';
import { createPage } from '@resources/Page/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createPage, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createPage(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.page.create',
						defaultMessage:
							'A new Page has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.page',
					defaultMessage: 'Create Page',
				})}
			</Title>
			<PageForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createPage })(Create);
